/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";
import {
    Chart,
    DoughnutController,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    Filler
} from 'chart.js';

import 'whatwg-fetch';

// Register necessary Chart.js components
Chart.register(
    DoughnutController,
    ArcElement,
    Tooltip,
    Legend,
    Title,
    CategoryScale,
    Filler
);

/*------------------------------------*\
    GRAPH MODULE
\*------------------------------------*/
class Graph {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        const graphId = self.elem.getAttribute('data-graph-id');
        
        self.graphLegendId = graphId;

        fetch(`/ajax/chart/${graphId}`)
            .then((response) => response.json())
            .then((json) => this.makeChart(json))
            .catch((ex) => console.error('parsing failed', ex));
    }

    makeChart(json) {
        let self = this;

        const ctx = self.elem.getContext('2d');

        const chart = new Chart(ctx, {
            type: 'doughnut',
            data: json,
            options: {
                responsive: true,
                cutout: '35%',
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 100
                    }
                },
                plugins: {
                    legend: {
                        position: 'right',
                        labels: {
                            color: 'rgba(102, 0, 204, 1)',
                            boxWidth: 14
                        }
                    },
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem) {
                                const dataset = tooltipItem.dataset;
                                const index = tooltipItem.dataIndex;
                                return dataset.labels[index] + ' ' + dataset.units[index];
                            }
                        },
                        displayColors: true
                    },
                },
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        });

        const datasetArray = chart.config.data.datasets;

        let output = '<ul class="graph__label-list">';
        datasetArray.forEach((dataset) => {
            dataset.labels.forEach((label, index) => {
                const bgColor = dataset.backgroundColor[index];
                const data = dataset.data[index];
                output += `
                    <li class="graph__label-row">
                        <div class="graph__label-box" style="background-color:${bgColor}"></div>
                        <div>${label} <strong>${data}%</strong></div>
                    </li>`;
            });
        });
        output += '</ul>';

        $(".chartjs-legend" + this.graphLegendId).html(output);

        // Event handler setup
        const tabPane = document.querySelectorAll('.tabs__content .tab-pane');
        const tabLink = document.querySelectorAll('.tabs__nav-link');

        tabLink.forEach((link) => {
            link.addEventListener('click', () => {
                tabPane.forEach((pane) => {
                    if (!pane.classList.contains('active')) {
                        pane.classList.remove('fade', 'd-block');
                        pane.classList.add('d-none');
                    }
                });
            });
        });
    }
}

export default Graph;